<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Track Enquiry Reward Points
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="Positions"
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Positions"
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.position_id"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <div v-for="(level, index) in form.pointRange" :key="index">
            <v-row>
              <v-col cols="12" class="d-flex align-center">
                <h4 style="display: inline">Level {{ index + 1 }}</h4>
                <v-btn
                  v-if="form.pointRange.length > 1"
                  icon
                  class="ml-2"
                  color="red"
                  @click="removeLevel(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.min_amount"
                  label="Min Amount"
                  outlined
                  :error-messages="errors.min_amount"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.max_amount"
                  label="Max Amount"
                  outlined
                  :error-messages="errors.max_amount"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.given_points"
                  label="Given Points"
                  outlined
                  :error-messages="errors.given_points"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-btn class="mt-2 mb-4" color="secondary" @click="addLevel">
            <v-icon left>mdi-plus</v-icon>
            Add Next Level
          </v-btn>

          <v-divider class="my-5"></v-divider>

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Track Enquiry Reward Points
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "TrackProgressCreatePage",
  data() {
    return {
      form: {
        position_id: "",
        pointRange: [
          {
            min_amount: null,
            max_amount: null,
            given_points: null,
          },
        ],
      },
      positionItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`enquiry_form_reward_points/masters`)
        .then((masters) => {
          masters = masters.data;
          //Gift Categories
          masters.positions.forEach((position) => {
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    addLevel() {
      this.form.pointRange.push({
        min_amount: null,
        max_amount: null,
        given_points: null,
      });
    },
    removeLevel(index) {
      this.form.pointRange.splice(index, 1);
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/enquiry_form_reward_points", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
